import { PageMeta } from '../insights/insights.models';

export const MY_LEARNING_PAGE_META: Record<string, PageMeta> = {
	'^/my-learning/learning-journeys': {
		pagegroup: 'my-learning',
		pagename: 'learning-journeys'
	}
};
